import { useState, useEffect } from "react";
import api from "../../api/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from "../../components/LoadingBtn/LoadingBtn";
import logo from "../../assets/logo.png";
import { Autocomplete, TextField } from "@mui/material";
import "./ResetPassword.css";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/api/users/drop")
      .then((res) => {
        if (res.data.responseCode === 200) {
          setUsers(res.data.response);
        } else {
          toast.error(res.data.message || "Failed to fetch users");
        }
      })
      .catch(() => toast.error("Failed to fetch users"));
  }, []);

  const handleReset = (e) => {
    e.preventDefault();
    if (!selectedUser) {
      toast.error("Please select a user");
      return;
    }

    setLoading(true);

    api
      .put(`/api/admin/reset-password/${selectedUser.identy}`, { newPassword })
      .then((res) => {
        if (res.data.responseCode === 200) {
          toast.success("Password reset successfully!");
          setNewPassword("");
          setSelectedUser(null);
          setTimeout(() => navigate("/dashboard"), 1000);
        } else {
          toast.error(res.data.message || "Reset failed");
        }
      })
      .catch((err) => {
        const message = err?.response?.data?.message || "Reset failed";
        toast.error(message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}

      <div className="resetPasswordContainer">
        <div className="resetCard">
          <img src={logo} alt="ICS Logo" />
          <h3 className="mb-3 mt-5">Admin Reset Password</h3>

          <form onSubmit={handleReset} className="resetForm">
            {/* Autocomplete User */}
            <Autocomplete
              className="selectUser"
              options={users}
              getOptionLabel={(option) => option.username}
              value={selectedUser}
              onChange={(event, newValue) => setSelectedUser(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select User"
                  className="mt-2"
                  variant="outlined"
                  size="small"
                  required
                />
              )}
            />

            {/* New Password */}
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="passwordInput"
            />

            {/* Reset Button */}
            <LoadingBtn
              text={loading ? "Resetting..." : "Reset Password"}
              loading={loading}
              type="submit"
              disabled={loading}
              sx={{
                height: "55px",
                width: "270px",
                borderRadius: "10px",
                fontSize: "16px",
                backgroundColor: "#386ED0",
                "&:hover": {
                  backgroundColor: "#2f5bb7",
                },
              }}
            />
          </form>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;


